/**
 * @fileoverview Connect a deadline proposal to backend-selected existing-event replacement candidates. The parent owns the selected replacement and approval action; this control owns candidate loading/presentation. Choosing a candidate does not itself replace or delete a calendar event.
 */

import React, { useEffect, useState } from 'react';
import api from '../../api';



export default function DeadlineReplacementPicker({ deadlineId, replacement, onChange, disabled = false }) {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);

    useEffect(

    () => {
        let active = true;
        setLoading(true);
        setEvents([]);
        setError('');
        api.get(`/ai-calendar/deadlines/${deadlineId}/replacement-candidates`)
            .then(({ data }) => { if (active) setEvents(data.events || []); })
            .catch(() => { if (active) setError('Could not load existing deadlines.'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [deadlineId, attempt]);

    return <div className="deadline-replacement-picker" style={{ margin: '16px 0', textAlign: 'left' }}>
        <label htmlFor={`replaces-${deadlineId}`}>Replaces</label>
        <select id={`replaces-${deadlineId}`} value={replacement?.id || ''}
            disabled={disabled || loading || Boolean(error)}
            style={{ display: 'block', width: '100%', marginTop: 6, padding: 8, color: 'inherit', background: 'var(--surface-card, #202733)', border: '1px solid var(--surface-border, #6b7280)', borderRadius: 6 }}
            onChange={(event) => onChange(events.find(item => String(item.id) === event.target.value) || null)}>
            <option value="">{loading ? 'Loading existing deadlines…' : 'Add as a new deadline'}</option>
            {events.map(item => <option key={item.id} value={item.id}>
                {item.start_date.slice(0, 10)} — {item.title}
            </option>)}
        </select>
        {error && <p role="alert">{error} <button type="button" onClick={() => setAttempt(value => value + 1)}>Retry</button></p>}
        {replacement && <p role="status" style={{ margin: '8px 0 0' }}>
            <s>{replacement.start_date.slice(0, 10)} — {replacement.title}</s>
            <br />The old deadline and its reminders will be removed from both calendars when you approve.
        </p>}
    </div>;
}
